export default __webpack_public_path__ + "static/media/CEM-NVR.2d0332bc.jpg";